export default {
  title: 'Hidden sections',
  info: 'Sections this view decided not to render for the current model, plan and KPI, with the reason and the exact condition that failed. Only what is hidden is listed — everything else is on screen.',
  section: 'Section',
  reason: 'Reason',
  condition: 'Condition',
  nothingHidden: 'Nothing is hidden: every section has the data it needs.',
  // Reason vocabulary, keyed by the code each view emits.
  reasons: {
    missingData: 'The report does not include this data',
    emptyData: 'The data is there but empty',
    allZero: 'Every value is zero',
    modelType: 'Not available for this model type',
    clientSetting: 'Turned off by a client setting',
    role: 'Hidden for your role',
    notAdditive: 'The KPI is not additive, so the figure would not reconcile',
    replacedBy: 'Replaced by "{section}"',
    drillDown: 'Superseded by the drill-down inside "{section}"',
    notEnoughPeriods: 'Needs more than one period',
    noChannels: 'No channel has both spend and attribution',
    noModelReport: 'The model report has not been calculated or loaded yet',
    noSpendSeries: 'The plan has no per-channel spend to overlay',
    parentHidden: 'Its parent section is hidden',
    notApplicable: 'Not computable with this data'
  }
}
